import { render, staticRenderFns } from "./FormRelatoriosPlanos.vue?vue&type=template&id=2ebd9e68&scoped=true"
import script from "./FormRelatoriosPlanos.vue?vue&type=script&lang=js"
export * from "./FormRelatoriosPlanos.vue?vue&type=script&lang=js"
import style0 from "./FormRelatoriosPlanos.vue?vue&type=style&index=0&id=2ebd9e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd9e68",
  null
  
)

export default component.exports